import React, { FC, useState, useEffect, useRef } from "react";
import { FaTimesCircle as CrossIcon } from "react-icons/fa";
import { AiOutlineClose as CloseIcon } from "react-icons/ai";

interface Toast {
  id: string;
  title: string;
  message: string;
}

interface Props extends Toast {
  duration?: number;
}

const ErrorToast: FC<Props> = ({ id, title, message, duration }) => {
  const [toast, setToast] = useState<Toast | undefined>();
  const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);

  useEffect(() => {
    setToast({ id, title, message });
    timeoutRef.current = setTimeout(
      () => setToast(undefined),
      duration || 7000
    );
    return () => {
      if (timeoutRef?.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [id, title, message, duration]);

  const handleClose = () => {
    if (timeoutRef?.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setToast(undefined);
  };

  if (!toast) return null;

  return (
    <div className="bg-white rounded-lg border-gray-300 border p-3 shadow-lg fixed bottom-4 right-4 animate-fade-in-up max-w-xs">
      <div className="flex flex-row items-center">
        <div className="px-2">
          <CrossIcon className="w-8 h-8 text-red-500" />
        </div>
        <div className="ml-2 mr-6">
          <h3 className="font-medium">{toast.title}</h3>
          <span className="block text-gray-500 text-xs">{toast.message}</span>
        </div>
        <button
          className="absolute top-1 right-1 p-1 cursor-pointer hover:bg-slate-100 rounded-full"
          onClick={handleClose}
        >
          <CloseIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default ErrorToast;
